var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-toggle-selection style-selection page-container" },
    [
      _c(
        "div",
        {
          staticClass: "hero-container",
          style: {
            backgroundImage: "url(" + _vm.imageUrl(_vm.heroImage) + ")"
          },
          on: { touchstart: _vm.dragstart, touchend: _vm.dragend }
        },
        [
          _c(
            "div",
            { staticClass: "vertical-align" },
            [
              _c("div", { staticClass: "hero-slide-title" }, [
                _vm._v(
                  "\n                Shop the coolest looks, styled by the industry's best\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "button", attrs: { to: "shop" } },
                [_vm._v("\n                Shop Featured\n            ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7edd40b9", { render: render, staticRenderFns: staticRenderFns })
  }
}